'use strict';

exports.__esModule = true;
exports.initAjaxActivity = exports.putRequest = exports.ajaxActions = exports.ajaxRequests = exports.putReqToPipeline = exports.cancelAjax = exports.pipeline = undefined;

var _pipeline = require('./pipeline');

var _pipeline2 = _interopRequireDefault(_pipeline);

var _middlewares = require('./ajax/middlewares');

var _activity = require('./ajax/activity');

var _activity2 = _interopRequireDefault(_activity);

var _reducer = require('./ajax/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _actions = require('./ajax/actions');

var _utils = require('./ajax/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ajaxActions = {
  cancel: _actions.cancel,
  remove: _actions.remove,
  removeRange: _actions.removeRange
};

exports.pipeline = _pipeline2['default'];
exports.cancelAjax = _middlewares.cancelAjax;
exports.putReqToPipeline = _middlewares.putReqToPipeline;
exports.ajaxRequests = _reducer2['default'];
exports.ajaxActions = ajaxActions;
exports.putRequest = _utils.putRequest;
exports.initAjaxActivity = _activity2['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/index.js
 ** module id = 16
 ** module chunks = 0
 **/